import React, { useState } from "react";
import { MainButtons, RodSettings } from "../../enum/enums";
import DataContainer from "../../services/DataContainer";
import { Button } from "../Button/Button";
import { VarianButtonEnum } from "../../enum/Button/variantButton.model";
import { colorButton } from "../../enum/Button/colorButton.model";
import { IconModelEnum } from "../../enum/Button/iconButton.model";
import dataContainer from "../../services/DataContainer";
import { ImageRequest, ImageStatus } from "../../utils/useRenderOnDemand.types";
import { Props } from "./types";

const responseHandler = async (res: any) => {
  if (res.data.status === ImageStatus.Queued) {
    let tries = 0;
    res.data.tries = tries;
    let retry = true;
    while(retry) {
      await new Promise((resolve) => setTimeout(resolve, 1000));
      const response = await DataContainer.checkStatus(res.data);
      if (response.data.status === ImageStatus.Ready) {
        tries++;
        res.data.tries = tries;
        retry = false;
        return response.data.urlAssets[0];
      }
      tries++;
      res.data.tries = tries;
      if (tries > 15){
        retry = false;
        return response.data.urlAssets[0];
      }
    }
  }
  if (res.data.status === ImageStatus.Ready) {
    return res.data.urlAssets[0];
  }
};

let images: any[] = [];

const retryImages = async (renderSpec: ImageRequest, setIsLoading?:React.Dispatch<React.SetStateAction<boolean>>, setHasTimedOut?:React.Dispatch<React.SetStateAction<boolean>>, setImageSource?:React.Dispatch<React.SetStateAction<string>>) => {
  images = [];
  if (setIsLoading != undefined && setHasTimedOut != undefined){
    setHasTimedOut(false);
    setIsLoading(true);
  }
  const imageMap = [
    renderSpec
  ];
  const getImages = await Promise.all(imageMap.map(req => DataContainer.getRender(req).then(responseHandler)));
  images.push(...getImages);
  if (setImageSource != undefined){
    setImageSource(images[0]);
  }
  if (setIsLoading != undefined){
    setIsLoading(false);
  }
  if (setHasTimedOut != undefined){
    (images[0] != undefined) ? setHasTimedOut(false) : setHasTimedOut(true);
  }
};

const ErrorMessage = ({
  renderSpec, setIsLoading, setHasTimedOut, setImageSource }: Props) => {
  return (
    <div>
      <div className="h-full w-full flex justify-center items-center">
        <h1>
          {DataContainer.sectionKey(
            RodSettings.ROD_SETTINGS,
            RodSettings.ROD_ERROR
          )}
        </h1>
      </div>
      <Button
        variant={VarianButtonEnum.ICONBUTTON}
        text={dataContainer.sectionKey(MainButtons.MAIN_BUTTONS, MainButtons.RELOAD_BUTTON)}
        bgColor={colorButton.TRANSPARENT}
        customClassNames="m-auto"
        icon={IconModelEnum.RELOAD}
        onClickEvent={() => {
          setIsLoading ? retryImages(renderSpec, setIsLoading, setHasTimedOut, setImageSource) : retryImages(renderSpec);
        }}
      />
    </div>
  );
};

export default ErrorMessage;